module.exports = {"title":"Terms of Service and Usage (“Terms of use”)","legal_headline":"Terms of Service and Usage (“Terms of use”)","meta":{}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/in/setting/legal/locale.json
// module id = 647
// module chunks = 0 1 2 3 4 5